import { createContext, useContext, useMemo, useState } from 'react';
import { GuidedOnboardingState } from './../types/guided-onboarding-state';

const appState = {
  run: false,
  stepIndex: 0,
  steps: [] as any,
  tourActive: false,
};

export const AppContext = createContext({
  state: appState,
  setState: () => undefined,
});
AppContext.displayName = 'AppContext';

export function AppProvider(props: any) {
  const [state, setState] = useState(appState);

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [setState, state],
  );

  return <AppContext.Provider value={value} {...props} />;
}

export function useAppContext(): {
  setState: (patch: Partial<GuidedOnboardingState> | ((previousState: GuidedOnboardingState) => Partial<GuidedOnboardingState>)) => void;
  state: GuidedOnboardingState;
} {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('useAppContext must be used within a AppProvider');
  }

  return context;
}